import get from 'lodash/get'

import {
  fetchResource,
  fetchCollection
} from './index'

import { fetchWorkOrder } from './work-orders'
import { areaSchema } from '../schemas'

export const LOCATION_AREAS_REQUEST = 'LOCATION_AREAS_REQUEST'
export const LOCATION_AREAS_SUCCESS = 'LOCATION_AREAS_SUCCESS'
export const LOCATION_AREAS_FAILURE = 'LOCATION_AREAS_FAILURE'

function fetchAreasByLocation ({ url, locationId, query, paginationKey, reload }) {
  return fetchCollection({
    url,
    key: 'areas',
    query,
    schema: areaSchema,
    actions: [ LOCATION_AREAS_REQUEST, LOCATION_AREAS_SUCCESS, LOCATION_AREAS_FAILURE ],
    responseInterceptor: response => ({ ...response, locationId, query, paginationKey, reload })
  })
}

export function loadAreasByLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    const paginationKey = locationId.toString()

    let {
      nextPageUrl
    } = get(getState(), `pagination.areasByLocation.${paginationKey}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/areas`
    }

    return dispatch(fetchAreasByLocation({
      url: nextPageUrl,
      locationId,
      paginationKey
    }))
  }
}

export function searchAreasByLocation ({
  locationId,
  searchQuery,
  includeWorkTrackerFilters = false,
  nextPage
}) {
  return (dispatch, getState) => {
    const paginationKey = `${locationId}-${searchQuery}`

    let {
      nextPageUrl
    } = get(getState(), `pagination.areasByLocation.${paginationKey}`, {})

    let query

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/areas`
      query = { search: searchQuery }

      if (includeWorkTrackerFilters) {
        let {
          areaTypeId, subLocationId, serviceId, sortingId, amountIds, datePeriod: { startPeriod, endPeriod } = {}
        } = get(getState(), `workTrackerFilters.${locationId}`, {})

        if (startPeriod) { startPeriod = startPeriod.toISOString() }
        if (endPeriod) { endPeriod = endPeriod.toISOString() }

        query = {
          ...query,
          area_type: areaTypeId,
          sub_location: subLocationId,
          service: serviceId,
          order_cleaning_date: sortingId,
          amount: amountIds,
          startPeriod,
          endPeriod
        }
      }
    }

    if (nextPageUrl) {
      const hasNewFiltersPath = `workTrackerFilters.${locationId}.hasNewFilters`
      const hasNewFilters = get(getState(), hasNewFiltersPath, false)

      return dispatch(fetchAreasByLocation({
        url: nextPageUrl,
        query,
        locationId,
        paginationKey,
        reload: hasNewFilters
      }))
    }
  }
}

export function searchAvailableAreasByWorkOrder (workOrderId, searchQuery, nextPage) {
  return (dispatch, getState) => {
    const perform = () => {
      const locationId = getState().workOrders[workOrderId].location
      const paginationKey = `${locationId}-${workOrderId}-search`

      let {
        nextPageUrl
      } = get(getState(), `pagination.areasByLocation.${paginationKey}`, {})

      if (!nextPage) {
        nextPageUrl = `/locations/${locationId}/areas`
      }

      return dispatch(fetchAreasByLocation({
        url: nextPageUrl,
        query: { search: searchQuery, available_for_work_order_id: workOrderId, with_recent_overcleaning: true },
        locationId,
        paginationKey,
        reload: !nextPage
      }))
    }

    if (getState().workOrders[workOrderId]) {
      perform()
    } else {
      dispatch(fetchWorkOrder(workOrderId)).then(perform)
    }
  }
}

export const AREA_REQUEST = 'AREA_REQUEST'
export const AREA_SUCCESS = 'AREA_SUCCESS'
export const AREA_FAILURE = 'AREA_FAILURE'

export function fetchArea (areaId) {
  return fetchResource({
    url: `/areas/${areaId}`,
    key: 'area',
    schema: areaSchema,
    actions: [ AREA_REQUEST, AREA_SUCCESS, AREA_FAILURE ]
  })
}

export const SET_CURRENT_SEARCH = 'SET_CURRENT_SEARCH'

export function setCurrentSearch (search) {
  return {
    type: SET_CURRENT_SEARCH,
    search
  }
}

export const SET_CURRENT_FILTER = 'SET_CURRENT_FILTER'

export function setCurrentFilter (areaId) {
  return {
    type: SET_CURRENT_FILTER,
    areaId
  }
}

export const RESET_CURRENT_FILTER = 'RESET_CURRENT_FILTER'

export function resetCurrentFilter (areaId) {
  return {
    type: RESET_CURRENT_FILTER
  }
}



// WEBPACK FOOTER //
// ./src/actions/areas.js